import { type Database } from '@databases/model/database';

import {
  serializeDatabaseContents,
  serializeSelectedCells,
  type SelectedCells,
} from './contents';
import { serializeDatabaseSchema } from './schema';
import { serializeDatabaseViews } from './view';
import { Warnings } from './warnings';

export type { SelectedCells } from './contents';
export { createSelectedCells, getCellKey } from './contents';

export type SerializeDatabaseOptions = {
  currentViewId?: string;
  entryIds?: readonly string[];
  fieldIds?: readonly string[];
};

export function serializeDatabase(
  database: Database,
  selectedCells: SelectedCells,
  options: SerializeDatabaseOptions = {}
) {
  const { currentViewId, entryIds, fieldIds } = options;

  const warnings = new Warnings();
  let output = '';
  const rowIdToEntryIdMappings = new Map<string, string>();

  output += serializeDatabaseSchema(database, warnings);
  output += '\r\n\r\n';

  output += serializeDatabaseViews(database, warnings, currentViewId);
  output += '\r\n\r\n';

  output += serializeDatabaseContents(
    database,
    warnings,
    rowIdToEntryIdMappings,
    entryIds,
    fieldIds
  );

  if (selectedCells.size > 0) {
    output += '\r\n\r\n';
    output += serializeSelectedCells(selectedCells, database, rowIdToEntryIdMappings);
  }

  return {
    output,
    warnings,
    rowIdToEntryIdMappings,
  };
}
